module.exports = __webpack_public_path__ + "static/media/bg-bottom3.d23a9d79.png";